import {
  FETCH_REVIEWS_SUCCESS,
  STAGE_NEW_REVIEW,
  CORRECT_REVIEW,
  SUBMIT_REVIEW_PENDING,
  SUBMIT_REVIEW_SUCCESS,
} from '../actions';

/* The state object is setup like this
 * {
 *   workflowStatus: 'create' | 'confirm' | 'submitPending' | 'submitted'
 *   invitationCode: 'code',
 *   booking: {
 *     accommodationTitle: 'title',
 *     arrival: '2021-05-01',
 *     departure: '2021-05-02',
 *     firstName: 'firstName',
 *   },
 *   ratings: {
 *     ratingArea: 1,
 *     ratingComfort: 2,
 *     ratingValue: 3,
 *     ratingCleanliness: 4,
 *   }
 *   reviewText: 'text',
 *   npsScore: 3,
 */

const initialState = {
  inivitationCode: undefined,
  booking: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REVIEWS_SUCCESS:
      return {
        ...action.payload,
        workflowStatus: 'create',
      };
    case STAGE_NEW_REVIEW:
      return {
        ...state,
        ratings: action.payload.ratings,
        reviewText: action.payload.reviewText,
        npsScore: action.payload.npsScore,
        workflowStatus: 'confirm',
      };
    case CORRECT_REVIEW:
      return {
        ...state,
        workflowStatus: 'create',
      };
    case SUBMIT_REVIEW_PENDING:
      return {
        ...state,
        workflowStatus: 'submitPending',
      };
    case SUBMIT_REVIEW_SUCCESS:
      return {
        ...state,
        workflowStatus: 'submitted',
      };
    default:
      return state;
  }
};
